import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isFeishuEnv } from "@/utils/feishu";
import { shouldSkipSignedOutLoginRedirect } from "@/utils/authRedirect";

/**
 * 未登录访问需登录页面时的统一跳转（与历史 Navbar 行为一致）。
 * 用于 SignedOut 下无 Nav 页面等场景；飞书环境由 App.tsx 的 Feishu SSO guard 单独处理，避免双跳/整页刷新循环。
 */
export default function SignedOutRedirectToLogin() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isFeishuEnv()) {
      return;
    }

    if (shouldSkipSignedOutLoginRedirect(pathname)) {
      return;
    }

    const thisPageUrl = window.location.href;
    const redirectUrl = thisPageUrl.replace("organization", "");
    window.location.href = "/login?redirect_url=" + redirectUrl;
  }, [pathname]);

  return null;
}
